import { z } from "zod";
import { AgentSchema } from "./IndexAgentResponse";

export const AgentResponseSchema = z.object({
    success: z.boolean(),
    message: z.string(),
    code: z.number(),
    data: AgentSchema,
});
